module.exports = __webpack_public_path__ + "media/images/mail-8e366b729872d2a137dbcf93ef3835c9.svg";